import { render, staticRenderFns } from "./aboutme.vue?vue&type=template&id=4a0f8558&scoped=true&"
import script from "./aboutme.vue?vue&type=script&lang=js&"
export * from "./aboutme.vue?vue&type=script&lang=js&"
import style0 from "./aboutme.vue?vue&type=style&index=0&id=4a0f8558&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f8558",
  null
  
)

export default component.exports